import script from "./mainFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./mainFooter.vue?vue&type=script&setup=true&lang=ts"

import "./mainFooter.vue?vue&type=style&index=0&id=9c48cdd2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c48cdd2"]])

export default __exports__